import React from 'react'
import MUIDataTable from 'mui-datatables';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import {getCarModel, getCarBrand , updateCarModel} from "../../../actions"
import { useState } from 'react';
import Toggle from 'react-toggle';
import { FaEdit } from 'react-icons/fa';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const CarMB = () => {
    const param = useParams()
    const dispatch = useDispatch()

    const [ carModel , setCarModel]=useState([])

    useEffect(() => {
        dispatch(getCarModel())
		dispatch(getCarBrand())
        localStorage.removeItem('editCarModel-data')
    },[])

    const carModelLists = useSelector(state => state.home.carModelList)?.response
    const carBrand = useSelector(state => state.home.CarBrandList)

    const editDataHandler = (id) => {
        console.log(id);
        const filteredData = carModelLists?.filter(model => model?.carModelId === id)
        localStorage.setItem('editCarModel-data', JSON.stringify(filteredData?.[0]))
        console.log("filteredData", filteredData);
    }

    useEffect(()=>{
        if(param?.brandId){
            var data = carModelLists?.filter(item=>item?.brandId===param?.brandId)
            console.log("data",data);
            setCarModel(data)
        }
    },[param.brandId])
// console.log("PAr",param?.brandId);
    const columns = [
		{
			name: 'name',
			label: 'Car Model Name',
			options: {
				filter: false,
				sort: true,
			},
		},
		{
			name: 'nameAr',
			label: 'Car Model Name Ar',
			options: {
				filter: false,
				sort: true,
			},
		},
		{
			name: 'brandId',
			label: 'Car Brand Name',
			options: {
				filter: false,
				sort: true,
				customBodyRender: (brandId) => {
					var fill = carBrand?.response?.filter(item=>item?.brandId===brandId)
					// console.log("FLL",fill[0]?.name );
					return <span>{fill? fill[0]?.name : ""}</span>
				},
			},
		},
		{
			name: 'priority',
			label: 'Priority ',
			options: {
				filter: false,
				customBodyRender: (priority) => {
					return <span>{priority}</span>;
				},
			},
		},

		{
			name: 'status',
			label: 'Status',
			options: {
				filter: true,
				sort: true,
				customBodyRender: (status, tableMeta) => {
					var Id = tableMeta.rowData[4];
					// console.log(tableMeta.rowData[6]);
					return (
						<Toggle
							id={'status_' + Id}
							defaultChecked={status}
							value={status}
							// onChange={()=>handleStatusChange(Id, status)}
						/>
					);
				},
			},
		},
		{
			name: 'carModelId',
			label: 'Action',
			options: {
				filter: true,
				sort: true,
				customBodyRender: (carModelId) => {
                    // console.log("carModelId", carModelId);
					return (
						<div>
							<Link to={`/CarDetail/CarModel/${carModelId}?`} onClick={() => editDataHandler(carModelId)} >
                                <FaEdit style={{fontSize: '1.4rem'}} />
                            </Link>
						</div>
					);
				},
			},
		},

	];
    const options = {
		filter: false,
		viewColumns: false,
		print: false,
		download: false,
		selectableRows: 'none',
		textLabels: {
			body: {
				// noMatch: this.state.isSaving
				// 	? 'Loading data..!'
				// 	: 'Sorry, No Users Found',
				toolTip: 'Sort',
				columnHeaderTooltip: column => `Sort for ${column.label}`,
			},
		},
	};
  return (
    <div className='pcoded-inner-content'>
        <div className='main-body'>
            <div className='page-wrapper'>
                <div className='row'>
                    <div className='col-sm-12'>
                        <div className='card'>
                            <div className='card-header'>
                                {/* <Link
                                    to={`/CarDetail/CarModel/Add`}
                                    className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
                                    data-modal='modal-13'>
                                    {' '}
                                    <i className='icofont icofont-plus m-r-5'></i>
                                    Add Car Model
                                </Link> */}
                            </div>

                            <div className='card-block'>
                                <div className='dt-responsive table-responsive'>
                                    {carModelLists !== undefined ? (
                                        <MUIDataTable
                                            title={`Car Model`}
                                            className='table-responsive'
                                            data={carModel}
                                            columns={columns}
                                            options={options}
                                        />
                                    ) : (
                                        <h4>Loading...</h4>
                                    )}
                                    {/* </MuiThemeProvider> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CarMB